import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "filterable-list__list-item-dates"
};
const _hoisted_2 = { class: "filterable-list__list-item-date-connect" };
const _hoisted_3 = { class: "filterable-list__list-item-date" };
const _hoisted_4 = ["aria-label"];
const _hoisted_5 = ["aria-label", "title"];
import { onMounted, ref } from 'vue';
import { getDetailDate } from '../services';
import { useI18n, useConfig } from '../features';
export default /*#__PURE__*/ _defineComponent({
    __name: 'NewsListItemImageEventDates',
    props: {
        item: {}
    },
    setup(__props) {
        const { item } = __props;
        const dateDetails = ref([]);
        const { getLocale } = useI18n();
        const { dateTill } = useConfig();
        const locale = getLocale();
        onMounted(() => {
            const detailDate = getDetailDate(item?.date, locale);
            if (detailDate) {
                dateDetails.value.push(detailDate);
            }
            const detailEndDate = getDetailDate(item?.dateEnd, locale);
            if (detailEndDate && detailDate?.date !== detailEndDate?.date) {
                dateDetails.value.push(detailEndDate);
            }
        });
        return (_ctx, _cache) => {
            const _directive_set_attr = _resolveDirective("set-attr");
            return (dateDetails.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dateDetails.value, (dateDetail, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                            key: index + '_date'
                        }, [
                            (index == dateDetails.value?.length - 1 && index !== 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: index + '_abbr',
                                    class: "filterable-list__list-item-date is-connector"
                                }, [
                                    _withDirectives((_openBlock(), _createElementBlock("abbr", _hoisted_2, [
                                        _createTextVNode(" — ")
                                    ])), [
                                        [_directive_set_attr, { 'aria-label': _unref(dateTill), 'title': _unref(dateTill) }]
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("span", {
                                    "aria-label": dateDetail.dateDay,
                                    class: "filterable-list__list-item-date-day"
                                }, _toDisplayString(dateDetail.dateDay), 9 /* TEXT, PROPS */, _hoisted_4),
                                _createElementVNode("abbr", {
                                    "aria-label": dateDetail.dateMonthFull,
                                    title: dateDetail.dateMonthFull,
                                    class: "filterable-list__list-item-date-month"
                                }, _toDisplayString(dateDetail.dateMonthAbbr), 9 /* TEXT, PROPS */, _hoisted_5)
                            ])
                        ], 64 /* STABLE_FRAGMENT */));
                    }), 128 /* KEYED_FRAGMENT */))
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
